// NAVBAR component: fixed agency nav
//*******************************************************************
//dependencies
import React from 'react'
import {StaticQuery, graphql, Link} from 'gatsby'
//importing react-bootstrap nav component
import Navbar from 'react-bootstrap/Navbar'
//custom CSS files
import '../styles/navbar.css'
import '../styles/global.css'
import '../styles/mega-menu.css'
import Logo from './logo.png'
import Alert from 'react-bootstrap/Alert'
//*******************************************************************
//*******************************************************************
export default () => (
    <StaticQuery
        
        query={graphql`
            query {
                allButterCollection(filter: { id: { eq: "internal_navbar_links" } }) {
                    edges {
                        node {
                            id
                            value {
                                child_items {
                                    label
                                    url
                                },
                                url,
                                label,
                            }
                        }
                    }
                }
                home: allButterPage(filter: { slug: { eq: "index" } }) {
                    edges {
                        node {
                            logo
                            banner
                        }
                    }
                }
            }
        `}
        //page view
        render={data => (

            <div>    
					
				<Alert key="cyber-alert" variant="warning" id="alert-banner">
	
					<Alert.Link  href="https://www.cisecurity.org/cybersecurity-threats/alert-level/"><span id="elevated" >NJ's Current Cyber Alert Level: "GUARDED"</span></Alert.Link>
    
  				</Alert>
				
				<div>
					
					<div id='agencyBranding'>
						
						<table id="headerTable">
							
							<tr class="logoBlock tableRow">
								
								<td class="tableData" rowspan="3"><a href={data.allButterCollection.edges[0].node.value[0].url}><img class='navbar-brand' id='logo' alt="NJCCIC logo with text" src={Logo}/></a></td>
								<td class="tableData hyperLink">File a <a href="https://www.cyber.nj.gov/cyber-incident/">Cyber Incident Report</a>  |  File a <a href="https://www.cyber.nj.gov/breach/">Data Breach Report</a></td>
								
							</tr>
							
							<tr class="tableRow">
							
								<td class="tableData hyperLink"><a href="https://www.cyber.nj.gov/report/vulnerability-disclosure/report-a-vulnerability">Vulnerability Disclosure Form</a>  |  <a href="https://members.cyber.nj.gov/login?ec=302&startURL=%2Fs%2F">Member Portal Login</a></td>
							
							</tr>
							
							{/*<tr class="tableRow">
							
								<td class="tableData hyperLink"><a href="https://members.cyber.nj.gov/login?ec=302&startURL=%2Fs%2F">Member Portal Login</a></td>
							
							</tr>*/}
							
							<tr class="tableRow">
							
								<i class="material-icons" id="calendarIcon" align="right" title='Calendar'><a class="altIcons" href="https://www.cyber.nj.gov/calendar/">calendar_today</a></i>
	                			<i class="material-icons" id="mailIcon" align="right" title='Contact Us'><a class="altIcons" href="https://www.cyber.nj.gov/contact/">mail_outline</a></i>
                        		<i class="material-icons" id="searchIcon" align="right" title='Search'><a class="altIcons" href="https://www.cyber.nj.gov/search/">search</a></i>
							</tr>
						
						</table>
						
					</div>
				
				</div>
	
                <Navbar collapseOnSelect expand="lg" id="mainMenu">

                        <Navbar.Toggle aria-controls="responsive-navbar-nav"/>   
                            <Navbar.Collapse id='responsive-navbar-nav'>
    {/**************************MENU LIST*/}
                                <ul class='nav mobileStyle' id="navigationMenu">
	
    {/******************************REPORT DROPDOWN - index 1 */} 
									<li class="nav-item megamenu-li" id="static">
									<a class="menuOption pointer nav-link dropdown-toggle" href="" id="dropdown01" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">REPORT</a>
									<div class="dropdown-menu megamenu" aria-labelledby="dropdown01">
										<div class="row">
											<div class="col-sm-4 col-lg-3 offset-lg-3 megamenuLi">
												<div class="columnHeader">
													<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/report/">File a Report</a></h5>
												</div>
												
												<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/cyber-incident/">Cyber Incident Form</a>
												<a class="dropdown-item" href="https://www.cyber.nj.gov/breach/">Data Breach Form</a>
											</div>
											<div class="col-sm-4 col-lg-3 megamenuLi">
												<div class="columnHeader">
													<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/report/">Reporting Information</a></h5>
												</div>
												<a class="dropdown-item firstDropdownLink" href={data.allButterCollection.edges[0].node.value[4].url}>Learn More About Incident Reporting</a>
												<a class="dropdown-item" href="https://www.cyber.nj.gov/reporting-cybersecurity-incidents-to-the-njccic/">How To Report A Cyber Incident</a>
											</div>
											<div class="col-sm-4 col-lg-3 megamenuLi">
												<div class="columnHeader">
													<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/report/vulnerability-disclosure/vulnerability-disclosure-policy">Vulnerability Disclosure</a></h5>
												</div>
												<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/report/vulnerability-disclosure/report-a-vulnerability">Report a Vulnerability</a>
												<a class="dropdown-item" href="https://www.cyber.nj.gov/report/vulnerability-disclosure/vulnerability-disclosure-policy">Vulnerability Disclosure Policy</a>
												<a class="dropdown-item" href="https://www.cyber.nj.gov/report/vulnerability-disclosure/acknowledgements">Acknowledgements</a>
											</div>
										</div>
									</div>
								</li>
									
								<li class="nav-item megamenu-li">
									<a class="menuOption pointer nav-link" href={data.allButterCollection.edges[0].node.value[5].url} aria-haspopup="false" >ABOUT</a>
								</li>
									<li class="nav-item megamenu-li">
										<a class="menuOption pointer nav-link dropdown-toggle" href="" id="dropdown02" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">THREAT CENTER</a>
										<div class="dropdown-menu megamenu" aria-labelledby="dropdown02">
											<div class="row">
												<div class="col-sm-6 col-lg-3 megamenuLi">
													<div class="columnHeader">
														<h5 class="megaLinkHeader">Publications</h5>
													</div>																										
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/threat-center/garden-state-cyber-threat-highlight">Garden State Cyber Threat Highlights</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/threat-center/announcements/">Announcements</a>
													<a class="dropdown-item" href={data.allButterCollection.edges[0].node.value[7].url}>Alerts & Advisories</a>
													<a class="dropdown-item" href={data.allButterCollection.edges[0].node.value[8].url}>Public Data Breaches</a>
													<a class="dropdown-item" href={data.allButterCollection.edges[0].node.value[9].url}>Threat Analysis Reports</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/weekly-bulletin">Weekly Bulletin</a>
												</div>
												<div class="col-sm-6 col-lg-3 megamenuLi">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/threat-center/threat-profiles">Threats</a></h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/threat-center/apache-log4j-vulnerability-guidance/">Apache Log4j Vulnerability Guidance</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/informational-report/identity-theft-and-compromised-pii">Identity Theft & Compromised PII</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/threat-center/threat-profiles#botnets">Botnets</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/threat-center/threat-profiles#mobile-malware">Mobile Malware</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/threat-center/threat-profiles#ransomware">Ransomware</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/threat-center/threat-profiles#trojans">Trojans</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/threat-center/threat-profiles#other-malware">Other Malware</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/threat-center/threat-profiles">View All</a>
												</div>
												<div class="col-sm-6 col-lg-3 megamenuLi">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/threat-center/covid-19-cybersecurity-resources">COVID-19 Cybersecurity Resources</a></h5>
													</div>
													{/*<div class='dropdown-divider'></div>*/}
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/threat-center/covid-19-cybersecurity-resources#telecommuting-tips">Telecommuting Tips</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/threat-center/covid-19-cybersecurity-resources#key-alerts">Key Alerts</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/threat-center/covid-19-cybersecurity-resources#covid-19-resources">COVID-19 Resources</a>
												</div>
												<div class="col-sm-6 col-lg-3 megamenuLi">
													<div class="columnHeader">
														<h5 class="megaLinkHeader">Election Security</h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/threat-center/election-security">General Information</a>
												</div>
											</div>
										 </div>
									</li>
									<li class="nav-item megamenu-li">
										<a class="menuOption pointer nav-link dropdown-toggle" href="" id="dropdown02" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">LEARN</a>
										<div class="dropdown-menu megamenu" aria-labelledby="dropdown02">
											<div class="row">
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/learn/business-government-resources">Business & Government Resources</a></h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/cybersecurity-for-critical-infrastructure/">Cybersecurity for Critical Infrastructure</a>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/cybersecurity-for-small-business/">Cybersecurity for Small & Medium-Sized Businesses</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/NJ-Statewide-Information-Security-Manual.pdf">NJ SISM</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/cybersecurity-strategic-plan">NJCCIC Strategic Plan 2021-2025</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/cybersecurity-policy-templates">Cybersecurity Policy Templates</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/business-government-resources#cyber-disaster-recovery">Cyber Disaster Recovery</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/business-government-resources#publications">IT Security Publications</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/threat-center/election-security">Election Security</a>
												</div>
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/learn/cybersecurity-best-practices">Cybersecurity Best Practices</a></h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/learn/cybersecurity-best-practices#the-basics">The Basics</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/cybersecurity-best-practices#account-security">Account Security</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/informational-report/identity-theft-and-compromised-pii">Identity Theft & Compromised PII</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/family-online-cyber-safety">Cyber Safety for Families & Individuals</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/announcements/cisa-known-exploited-vulnerabilities-catalog">CISA: Known Exploited Vulnerability Catalog</a>
												</div>
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/learn/be-sure-to-secure">Cybersecurity Guides</a></h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/learn/technical-guides#instructional-guides">Instructional Guides</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/technical-guides#mitigation-guides">Mitigation Guides</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/be-sure-to-secure#social-engineering-reports">Social Engineering</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/be-sure-to-secure#cyber-safety-reports">Cyber Safety & Tips</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/be-sure-to-secure#ai-iot-and-cryptography-reports">AI, IoT, & Cryptography</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/technical-guides#security-guides">This Is Security Series</a>
												</div>
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/learn/presentations">Presentations</a></h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/learn/presentations">General Information</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/presentations/presentation-request">Schedule A Presentation</a>
												</div>
											</div>
											<div class="row" id="megaMenuRow2">
												
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/slcgp/">NJ State & Local Cybersecurity Grant Program</a></h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/slcgp/">About The NJ SLCGP</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/NJ-SLCGP-Strategic-Plan.pdf">SLCGP Strategic Plan</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/NJ-SLCGP-Planning-Committee-Charter.pdf">SLCGP Charter</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/local-consent-agreement/">Local Consent Agreement</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/nj-slcgp-resource-request-application/">FY23 Application</a>
												</div>									
												
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/sdwcgp/">Safe Drinking Water Cybersecurity Grant Program</a></h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/sdwcgp/">About The SDWCGP</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/nj-sdwcgp-resource-request-application/">SDWCGP Application</a>
													
												</div>
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/learn">Online Learning</a></h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/learn#e-learning">E-Learning Resources</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/e-learning-for-kids">E-Learning For Students</a>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/learn/cyber-programs-in-nj/">Cybersecurity Education in NJ</a>
												</div>
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/learn/partner-resources">Partner Resources</a></h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/learn/partner-resources#information-sharing">Information Sharing</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/partner-resources#training-certification">Training & Certifications</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/learn/partner-resources#additional-resources">Additional Resources</a>
												</div>
											</div>
										 </div>
									</li>
									<li class="nav-item megamenu-li">
										<a class="menuOption pointer nav-link dropdown-toggle" href="" id="dropdown02" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">EVENTS</a>
										<div class="dropdown-menu megamenu" aria-labelledby="dropdown02">
											<div class="row">
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader">Alice in Cyberspace</h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/news-events/alice-in-cyberspace">Learn More</a>
												</div>
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader">Cyber Resilience Symposiums</h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/events/achieving-cyber-resilience-for-k-12/">For K-12 Schools</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/events/achieving-cyber-resilience-for-new-jersey-public-sector-partners/">For Public Sector Partners</a>
												</div>
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader">Cybersecurity Awareness Month</h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/news-events/ncsam">Discover NCSAM</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/news-events/poster-contest">Poster Contest</a>
												</div>
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader">CyberStart America</h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/news-events/girls-go-cyberstart">Learn More</a>
												</div>
											</div>
										 </div>
									</li>
									<li class="nav-item megamenu-li">
										<a class="menuOption pointer nav-link dropdown-toggle" href="" id="dropdown02" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">JOIN</a>
										<div class="dropdown-menu megamenu" aria-labelledby="dropdown02">
											<div class="row">
												<div class="col-sm-6 col-lg-3 offset-lg-6">
													<div class="columnHeader">
														<h5 class="megaLinkHeader">Member Portal</h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://members.cyber.nj.gov/">Login</a>
												</div>
												<div class="col-sm-6 col-lg-3">
													<div class="columnHeader">
														<h5 class="megaLinkHeader"><a href="https://www.cyber.nj.gov/members/">Become a Member</a></h5>
													</div>
													<a class="dropdown-item firstDropdownLink" href="https://www.cyber.nj.gov/members/">Sign Up</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/internships/">College Internships</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/high-school-internships/">High School Internships</a>
													<a class="dropdown-item" href="https://www.cyber.nj.gov/careers/">Careers</a>
												</div>
											</div>
										 </div>
									</li>
								</ul>
					
        {/*</div>*/}        </Navbar.Collapse>
						
                    </Navbar>
                
{/**************NAVBAR END*/}  
                
            </div>
        )}
  />
)













